import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Star, Work } from "@material-ui/icons";
import LuggageIcon from "@mui/icons-material/Luggage";
import classes from "./FlightList.module.css";

const externalStyle = {
  color: "var(--themegreen)",
  fontSize: "1rem",
  marginRight: "8px",
};
const icons = {
  star: <Star />,
  work: <Work />,
  brifcase: <i className="fa fa-suitcase" style={externalStyle}></i>,
  luggage: <LuggageIcon />,
};
const TabWithIcon = ({ icon, text, title }) => {
  return (
    <Grid className={classes["tab-icon-container"]} title={title}>
      {icons[icon]}
      <Typography component="p">{text}</Typography>
    </Grid>
  );
};

export default React.memo(TabWithIcon);
